<template>
  <div class="container">
    <div class="date-wraper" @click="showDatePicker">
      {{formItem.title}}
      <p>
        {{formatValue}}
        <span class="info-arrow"></span>
      </p>
    </div>
    <p
      :class="['status-tip','tip_'+formItem.field_status]"
      v-show="formItem.field_result"
    >{{formItem.field_result}}</p>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { post } from "../../tools/request";
import { emitFormUpdate } from "../../tools/utils";
export default {
  props: ["formItem", "idx", "cm"],
  computed: {
    ...mapState(["_ticket"]),
    formatValue() {
      let res = /(\d{4})-(\d{2})-(\d{2})/.exec(this.formItem.value);
      return res ? `${res[3]}/${res[2]}/${res[1]}` : "";
    }
  },
  mounted() {
    if ("" + this.formatValue) {
      this.formItem.valid = true;
      emitFormUpdate(this, this.idx);
    }
  },
  methods: {
    showDatePicker() {
      //已通过则不再允许做操作
      if (this.formItem.field_status == 4) {
        return;
      }
      //处理下当前值
      let val = new Date();
      if (this.formItem.value) {
        val = new Date(this.formItem.value);
      }
      if (!this.datePicker) {
        this.datePicker = this.$createDatePicker({
          max: new Date(),
          min: new Date(1939, 0, 1),
          format: { month: "MM", date: "DD" },
          value: val,
          cancelTxt: this.$t("取消"),
          confirmTxt: this.$t("确认"),
          onSelect: this.checkCommit,
          onChange: (...a) => console.log(a),
          onCancel: (...a) => console.log(a)
        });
      }
      this.datePicker.show();
    },
    checkCommit(...a) {
      this.formItem.value = a[2].join("-");
      this.formItem.valid = true;
      emitFormUpdate(this, this.idx);
      //if need add
      if (this.cm) {
        this.addInfo();
      }
    },
    //提交物料
    addInfo() {
      // 更新icon --checking
      this.formItem.field_status = 3;
      this.formItem.field_result = this.$t("检测中");
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      let val = this.formItem.value;
      if (this.formItem.clear_format) {
        val = this[this.formItem.format](val, true);
      }
      up.append(this.formItem.key, val);
      post(process.env.ADD_AUDI_INFO, up)
        .then(() => {
          // success do nothing
        })
        .catch(err => {
          this.formItem.field_status = 5;
          this.formItem.field_result = err.errmsg;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding-right: 0.36rem;
  margin-bottom: 0.1rem;
  font-size: 0.36rem;
  color: #414141;
  background: #fff;
}
.status-tip {
  width: 7.1rem; //铺满右侧
  margin-right: 0;
}
.date-wraper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 1.4rem;
  p {
    color: #323233;
  }
}
</style>

